import {
	FILTER_CLEAR,
	FILTER_IS_OPEN,
	FILTER_LANGUAGE,
	FILTER_SELECTED_TOPICS,
	FILTER_OPEN_CATEGORIES,
	FILTER_SELECTED_CATEGORIES,
} from '../types/filter';

import { updateObject } from '../utility';

const initialState = {
	filterIsOpen: {},
	openCategories: {},
	selectedTopics: {},
	selectedCategories: {},
	currentLanguage: {},
};

const clearFilters = (state, action) => {
	const currentLanguage = {
		...state.filterLanguage,
	};

	const openCategories = {
		...state.openCategories,
	};

	const selectedCategories = {
		...state.selectedCategories,
	};

	const selectedTopics = {
		...state.selectedTopics,
	};

	Array.from(action.filterIds).forEach((filterId) => {
		currentLanguage[filterId] = false;
		openCategories[filterId] = [];
		selectedCategories[filterId] = [];
		selectedTopics[filterId] = [];
	});

	return updateObject(state, {
		currentLanguage,
		openCategories,
		selectedCategories,
		selectedTopics,
	});
};

const toggleOpen = (state, action) => {
	const filterIsOpen = {
		...state.filterIsOpen,
		[action.filterId]: action.filterIsOpen,
	};

	return updateObject(state, {
		filterIsOpen,
	});
};

const changeLanguage = (state, action) => {
	const currentLanguage = {
		...state.currentLanguage,
		[action.filterId]: action.currentLanguage,
	};

	return updateObject(state, {
		currentLanguage,
	});
};

const updateSelectedTopics = (state, action) => {
	const selectedTopics = {
		...state.selectedTopics,
		[action.filterId]: action.selectedTopics,
	};

	return updateObject(state, {
		selectedTopics,
	});
};

const updateOpenCategories = (state, action) => {
	const openCategories = {
		...state.openCategories,
		[action.filterId]: action.openCategories,
	};

	return updateObject(state, {
		openCategories,
	});
};

const updateSelectedCategories = (state, action) => {
	const selectedCategories = {
		...state.selectedCategories,
		[action.filterId]: action.selectedCategories,
	};

	return updateObject(state, {
		selectedCategories,
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case FILTER_CLEAR:
			return clearFilters(state, action);
		case FILTER_IS_OPEN:
			return toggleOpen(state, action);
		case FILTER_LANGUAGE:
			return changeLanguage(state, action);
		case FILTER_SELECTED_TOPICS:
			return updateSelectedTopics(state, action);
		case FILTER_OPEN_CATEGORIES:
			return updateOpenCategories(state, action);
		case FILTER_SELECTED_CATEGORIES:
			return updateSelectedCategories(state, action);
		default:
			return state;
	}
};

export default reducer;
